





























import Vue from 'vue';
import { PropType } from 'vue';
import { AttachmentDto } from "@/api/appService";

export default Vue.extend({
  name: 'AttachmentListItem',
  props: {
    item: {
      type: Object as PropType<AttachmentDto>,
      required: true
    }
  },
  data() {
    return {
      showVideoPlayer: false
    };
  },
  computed: {
    isVideo(): boolean {
      if (!this.item.fileName) return false;
      let fileName=this.item.fileName
      const videoExtensions = ['.mp4', '.webm', '.ogg', '.mov', '.avi', '.wmv'];
      return videoExtensions.some(ext =>
        fileName.toLowerCase().endsWith(ext)
      );
    },
    videoType(): string {
      if (!this.item.fileName) return 'video/mp4';
      const ext = this.item.fileName.split('.').pop()?.toLowerCase();
      switch(ext) {
        case 'mp4': return 'video/mp4';
        case 'webm': return 'video/webm';
        case 'ogg': return 'video/ogg';
        case 'mov': return 'video/quicktime';
        default: return 'video/mp4';
      }
    }
  },
  methods: {
    download(item: AttachmentDto) {
      window.open(item.url);
    },
    playVideo() {
      this.showVideoPlayer = true;
    }
  }
});
